import SingleFileIcon from '@/common/assets/icons/singleFileIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography.tsx';
import FileTypeLabel from '@/common/components/fileTypeLabel/FileTypeLabel.tsx';
import { IncidentDetailsMainCardHeaderProps } from '@/modules/adjusterReportModules/IncidentDetails/components/incidentDetails/IncidentDetailsMainCardHeader.types.ts';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const IncidentDetailsMainCardHeader = ({
  fileNumber,
  fileType,
  className,
  svgColor,
}: IncidentDetailsMainCardHeaderProps) => {
  return (
    <>
      <Box
        className={className}
        display="flex"
        mx={14}
        py={6}
        borderBottom="1px"
        justifyContent="space-between"
        alignItems="center"
        borderStyle="dashed"
      >
        <Flex alignItems="center" gap={8}>
          <Box
            paddingInlineEnd="7"
            className={css({
              borderInlineEndWidth: '1px solid',
              borderColor: 'pink-1',
            })}
          >
            <SingleFileIcon width={20} height={20} stroke={token(svgColor)} />
          </Box>
          <Typography color="black-3" textStyle="b4">
            پرونده <span dir="ltr">{fileNumber}</span>
          </Typography>
        </Flex>
        <Box>
          <FileTypeLabel fileType={fileType} />
        </Box>
      </Box>
    </>
  );
};

export default IncidentDetailsMainCardHeader;
